import { useCallback } from 'react';

import { getHelpUrl } from '@change-corgi/config/help';
import { useTracking } from '@change-corgi/core-react/tracking';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import { useLocale } from '#src/app/shared/hooks/l10n';

type Result = ModelHookResult<
	{
		promotionUrl: string;
		promotionHelpUrl: string;
		shouldUseDonationLanguage: boolean;
	},
	{
		trackPromotePetitionClick: () => void;
		trackLearnMoreClick: () => void;
	}
>;

export function usePromoteYourPetition(): Result {
	const track = useTracking();
	const locale = useLocale();
	const {
		data: {
			petition,
			featureConfigs: { shouldUseDonationLanguage },
		},
	} = useStarterDashboardV2PageData();

	const trackPromotePetitionClick = useCallback(() => {
		void track('petition_manage_sponsor_ad', {
			target: 'promote_link',
		});
	}, [track]);
	const trackLearnMoreClick = useCallback(() => {
		void track('petition_manage_sponsor_ad', {
			target: 'learn_more_link',
		});
	}, [track]);

	return {
		data: {
			promotionUrl: `/p/${encodeURIComponent(petition.slug)}/sponsors/new?source_location=petition_manage_sponsor_ad`,
			promotionHelpUrl: getHelpUrl(locale, 'billing-membership/promoting-a-petition'),
			shouldUseDonationLanguage,
		},
		actions: {
			trackPromotePetitionClick,
			trackLearnMoreClick,
		},
	};
}
